import React, { useState } from 'react'
import * as API from '../../utility/api'
import moment from 'moment'

const ACTIONS = {
  SALES: 'sales',
  DEBT: 'debt'
}

const Raports = ({ startDate, endDate, setRaportData }) => {
  const [eventID, setEventID] = useState(undefined)
  const [organizerID, setOrganizerID] = useState(undefined)
  const [action, setAction] = useState(ACTIONS.SALES)
  const [timeTarget, setTimeTarget] = useState('sold_at')
  const [loading, setLoading] = useState(false)

  const fetchData = e => {
    e.preventDefault()

    setLoading(true)
    // Format dates to include full day range and convert 
    const startTime = moment(new Date(`${startDate} 00:00:00`)).utc().format('YYYY-MM-DD HH:mm:ss');
    const endTime = moment(new Date(`${endDate} 23:59:59`)).utc().format('YYYY-MM-DD HH:mm:ss');
    API.POST(`admin/reports/${action}`, { start_time: startTime, end_time: endTime, organizerID, eventID, time_target: timeTarget })
      .then(({ data }) => {
        setLoading(false)
        setRaportData(data)
      })
      .catch(e => console.error(e))
  }

  return (
    <form className="admin-panel--raports--form-container" onSubmit={fetchData}>
      <div className="admin-panel--raports--form">
        <label htmlFor="eventID">Tapahtuman tunnus</label>

        <input
          id="eventID"
          type="number"
          placeholder="Tapahtuman ID"
          value={eventID}
          onChange={e => setEventID(e.target.value)}
        />

        <div className="break-sm" />

        <label htmlFor="orgID">Organisaation tunnus</label>

        <input
          id="orgID"
          type="number"
          placeholder="Organisaation ID"
          value={organizerID}
          onChange={e => setOrganizerID(e.target.value)}
        />

        <div className="break-lg" />

        <h3>Raportin tyyppi</h3>
        <label htmlFor="debt">
          <input
            id="debt"
            className="raport-radio"
            type="radio"
            checked={action === ACTIONS.DEBT}
            onChange={() => setAction(ACTIONS.DEBT)}
          />
          <span style={{ marginLeft: '5px' }}>Velka (sis. alv)</span>
        </label>

        <label htmlFor="sales">
          <input
            id="sales"
            className="raport-radio"
            type="radio"
            checked={action === ACTIONS.SALES}
            onChange={() => setAction(ACTIONS.SALES)}
          />
          <span style={{ marginLeft: '5px' }}>Myynti</span>
        </label>

        <div className="break-lg" />

        <h3>Ajakohdan kohdistus (Myyntiraportti)</h3>
        <label htmlFor="sold_at">
          <input
            id="sold_at"
            className="raport-radio"
            type="radio"
            checked={timeTarget === 'sold_at'}
            onChange={() => setTimeTarget('sold_at')}
          />
          <span style={{ marginLeft: '5px' }}>Lipun myyntiaika</span>
        </label>

        <label htmlFor="paytrail_payed_at">
          <input
            id="paytrail_payed_at"
            className="raport-radio"
            type="radio"
            checked={timeTarget === 'paytrail_payed_at'}
            onChange={() => setTimeTarget('paytrail_payed_at')}
          />
          <span style={{ marginLeft: '5px' }}>Tilauksen maksuaika</span>
        </label>

        <div className="break-lg" />

        <button disabled={loading} type="submit">
          {loading ? 'Ladataan....' : 'Lataa raportit'}
        </button>
      </div>
    </form>
  )
}

export default Raports
